import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";

import { parsePayrollAmount } from "../utils";
import { selectorPayrollRunContractorAmounts } from "./selectorPayrollRunContractorAmounts";

export type PayrollRunPendingDisbursement = {
  count: number;
  amount: number;
};

/**
 * How much of a contractor run has yet to be disbursed — its opened and pending
 * payables, which is what v1 counted by querying the run's payables directly.
 *
 * `undefined` when the run was read without the breakdown expanded, so the tile
 * can show a dash rather than claim nothing is outstanding.
 *
 * The API reports both a count and an amount per status (PLA-3613); the tile
 * renders the count for parity with v1, and the amount is here for when it
 * wants both.
 */
export const selectorPayrollRunPendingDisbursement = (
  payrollRun: PayrollRun | undefined
): PayrollRunPendingDisbursement | undefined => {
  const { payablesStatuses } = selectorPayrollRunContractorAmounts(payrollRun);

  if (!payablesStatuses) {
    return undefined;
  }

  const { opened, pending } = payablesStatuses;

  return {
    count: opened.count + pending.count,
    amount: parsePayrollAmount(opened.amount + pending.amount)
  };
};
